<template>
        <v-overlay>
          <!-- <CircularProgressBar/> -->
        <v-progress-circular
          indeterminate
          color="primary"
          size="100"
        ></v-progress-circular>
      </v-overlay>
</template>

<script>
// import CircularProgressBar from '../../common/circularProgressBar.vue';

export default {
  name: 'Loader',
  components: {
    // CircularProgressBar,
  },
};
</script>

<style scoped>
</style>
